import {
  AUTH_ERROR,
  FORM_SUBMISSION,
  SUBMISSION_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  USER_LOADED,
  USER_LOADING,
} from "../actions/type";
function authReducer(state, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case USER_LOADED:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        isSubmitting: false,
        user: action.payload,
      };
    case FORM_SUBMISSION:
      return {
        ...state,
        isSubmitting: true,
      };
    case SUBMISSION_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("authToken", action.payload.token);
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
        isSubmitting: false,
      };

    case LOGOUT_SUCCESS:
    case AUTH_ERROR:
      localStorage.removeItem("authToken");
      return {
        ...state,
        isLoading: false,
        user: null,
        users: null,
        isAuthenticated: false,
        isSubmitting: false,
      };

    default:
      return state;
  }
}

export default authReducer;
